module.exports = __webpack_public_path__ + "img/close.8f0b2c36.svg";